import React, { useEffect, useState } from "react";
import { Checkbox, Container, Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import cx from "classnames";

import { updateAccountSettings } from "actions/accounts";

import SaveChanges from "components/ui/Buttons/SaveButton";
import Cancel from "components/ui/Buttons/CancelButton";
import styles from "./settings.module.scss";
import ConfirmModal from "components/ui/ConfirmModal";
import { useParams} from "react-router-dom";
const initSettins = {
  hubEnabled: false,
  hubAdvancedEnabled: false,
  reportingEnabled: false,
  canDownloadAsset: false,
  disableSampleData: false,
  globalContactEnabled: false,
  collectionOverlayEnabled: false,
  unsubscribeLinkEnabled: false,
  collectionSectionEnabled: false,
  inContentSearchEnabled: false,
  whiteLabeled: false,
  microsoftEditAccessEnabled: false,
  allocadiaIntegrationEnabled: false,
  disableGlobalImageLibrary: false,
  recommendationEnabled: false,
  smallTalkEnabled: false,
  manageRoles: false,
  trialBanner: false,
  seekEnabled: false,
  subtitleEnabled: false,
  videoConversionEnabled: false,
  employerAdvocacyEnabled : false,
  coachingEnabled :false
};

export default function AccountSettings({ disabled, account }) {
  const dispatch = useDispatch();

  const updateSettings = useSelector((state) => state.accounts.updateSettings);

  const [open, setOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [settings, setSettings] = useState(initSettins);
  const [updatedSettings, setUpdatedSettings] = useState({});
  const [disableSave, setDisableSave] = useState(false);
  const params = useParams();

  useEffect(() => {
    if (account) {
      onSetSettings();
      setInitialRender(false);
    }
  }, [account]);

  useEffect(() =>{
    setDisableSave(false);

    return (() => {
      setDisableSave(false)
    })
  },[])

  useEffect(() => {
    if (!initialRender && !updateSettings.updating) {
      if (updateSettings.success) {
        toast.success(`Successfully updated settings for ${account.name}`);
      } else {
        toast.error(`failed to update settings for ${account.name}`);
      }
    }
  }, [updateSettings]);

  useEffect(() => {
    if (_.size (updatedSettings) > 0) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [updatedSettings]);
  
  const onSetSettings = () => {
    if (account) {
      setSettings({
        hubEnabled: account.hubEnabled,
        hubAdvancedEnabled: account.hubAdvancedEnabled,
        reportingEnabled: account.reportingEnabled,
        canDownloadAsset: account.canDownloadAsset,
        disableSampleData: account.disableSampleData,
        globalContactEnabled: account.globalContactEnabled,
        collectionOverlayEnabled: account.collectionOverlayEnabled,
        unsubscribeLinkEnabled: account.unsubscribeLinkEnabled,
        collectionSectionEnabled: account.collectionSectionEnabled,
        inContentSearchEnabled: account.inContentSearchEnabled,
        whiteLabeled: account.whiteLabeled,
        microsoftEditAccessEnabled: account.microsoftEditAccessEnabled,
        allocadiaIntegrationEnabled: account.allocadiaIntegrationEnabled,
        disableGlobalImageLibrary: account.disableGlobalImageLibrary,
        recommendationEnabled: account.recommendationEnabled,
        smallTalkEnabled: account.smallTalkEnabled,
        manageRoles: account.manageRoles,
        trialBanner: account.trialBanner,
        seekEnabled: account.seekEnabled,
        fliteviewSeekEnabled: account.fliteviewSeekEnabled,
        subtitleEnabled: account.subtitleEnabled,
        videoConversionEnabled: account.videoConversionEnabled,
        employerAdvocacyEnabled : account.employerAdvocacyEnabled,
        coachingEnabled : account.coachingEnabled
      });

    }
  };

  const onSettingsSave = () => {
    setOpen(true);
  };

  const onSettingsCancel = () => {
    setUpdatedSettings({});
    onSetSettings();
    setOpen(false);
  };

  const onSettingsChangeConfirm = () => {
    dispatch(updateAccountSettings({ id: account.id, settings: updatedSettings }));
    setOpen(false);
    setUpdatedSettings({});
  };

  const handleSettingsChange = (value) => {
    setSettings({
      ...settings,
      [value]: !settings[value],
    });

    if(updatedSettings[value] !== settings[value]) {
      setUpdatedSettings({
        ...updatedSettings,
        [value]: !settings[value]
      })
    }

    if(updatedSettings[value] === settings[value]) {
      var changedSettings = {...updatedSettings};
      delete changedSettings[value]; 
      setUpdatedSettings(changedSettings)
    }
  }
  if (params.product === "cleverstory") {
    return null;
  }
  return (
    <>
      <Container className={cx(styles.container)}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <span className={cx(styles.title)}>Settings </span>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Hub</div>
                      <div className={cx(styles.description)}>
                      Enable content curation and distribution to your teams.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.hubEnabled}
                        onChange={() => handleSettingsChange("hubEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Hub Advanced</div>
                      <div className={cx(styles.description)}>
                      Offering users advanced tools to tailor and edit the hub according to their specific preferences and needs.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.hubAdvancedEnabled}
                        onChange={() => handleSettingsChange("hubAdvancedEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Reporting</div>
                      <div className={cx(styles.description)}>
                      Provide users with valuable data reports for informed decision-making within the platform.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.reportingEnabled}
                        onChange={() => handleSettingsChange("reportingEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Download Asset</div>
                      <div className={cx(styles.description)}>
                      Enable users to  download assets from the hub.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.canDownloadAsset}
                        onChange={() => handleSettingsChange("canDownloadAsset")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Global Contact</div>
                      <div className={cx(styles.description)}>
                      Share a consolidated list of contacts with all users across your organization.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.globalContactEnabled}
                        onChange={() => handleSettingsChange("globalContactEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Collection Overlay</div>
                      <div className={cx(styles.description)}>
                      Add filters to your collection banner adding a personalized touch to your collections.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.collectionOverlayEnabled}
                        onChange={() => handleSettingsChange("collectionOverlayEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Unsubscribe Link</div>
                      <div className={cx(styles.description)}>
                      Include a  link in outgoing mailers, allowing end users to effortlessly manage their preferences and mute daily notification emails.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.unsubscribeLinkEnabled}
                        onChange={() => handleSettingsChange("unsubscribeLinkEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Collection Section</div>
                      <div className={cx(styles.description)}>
                      View a dedicated section of your collections within the hub.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.collectionSectionEnabled}
                        onChange={() => handleSettingsChange("collectionSectionEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Content Search</div>
                      <div className={cx(styles.description)}>
                      Elevate search capabilities by allowing in-depth search within the text of your assets.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.inContentSearchEnabled}
                        onChange={() => handleSettingsChange("inContentSearchEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>White Label</div>
                      <div className={cx(styles.description)}>
                      Allow users to customize end URLs according to their company branding, ensuring a personalized user journey.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.whiteLabeled}
                        onChange={() => handleSettingsChange("whiteLabeled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Microsoft Edit</div>
                      <div className={cx(styles.description)}>
                      Enhance document editing capabilities with our integration with Microsoft tools, allowing users to edit documents directly within our platform.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.microsoftEditAccessEnabled}
                        onChange={() => handleSettingsChange("microsoftEditAccessEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>
                        Allocadia Integration
                      </div>
                      <div className={cx(styles.description)}>
                      Optimize budgeting and planning by bringing Allocadia's capabilities directly into our platform.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.allocadiaIntegrationEnabled}
                        onChange={() => handleSettingsChange("allocadiaIntegrationEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>
                        Global Image Library
                      </div>
                      <div className={cx(styles.description)}>
                      Access a diverse set of default global images for banners and backgrounds.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.disableGlobalImageLibrary}
                        onChange={() => handleSettingsChange("disableGlobalImageLibrary")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Recommendation</div>
                      <div className={cx(styles.description)}>
                      Display a smart section of recommended assets, tailoring your hub to display content that matters most.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.recommendationEnabled}
                        onChange={() => handleSettingsChange("recommendationEnabled")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Live Talk</div>
                      <div className={cx(styles.description)}>
                      Interact with your end customers real-time as they view shared documents fostering dynamic communication.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.smallTalkEnabled}
                        onChange={() => handleSettingsChange("smallTalkEnabled")}                        
                        // disabled={disabled}
                        disabled
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Manage Roles</div>
                      <div className={cx(styles.description)}>
                      Provide administrators with the capability to customize user roles and permissions.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.manageRoles}
                        onChange={() => handleSettingsChange("manageRoles")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Sample Data</div>
                      <div className={cx(styles.description)}>
                      Populate new accounts with our default set of assets, streams and collections providing a quick and easy way to explore the capabilities of our platform.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.disableSampleData}
                        onChange={() => handleSettingsChange("disableSampleData")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>

            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Trial Banner</div>
                      <div className={cx(styles.description)}>
                      Display a notification banner in trial accounts, providing a timely reminder as the trial period approaches its end.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.trialBanner}
                        onChange={() => handleSettingsChange("trialBanner")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Seek</div>
                      <div className={cx(styles.description)}>
                      Utilize the power of AI for improved search within assets and across the hub.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.seekEnabled}
                        onChange={() => handleSettingsChange("seekEnabled")}                        
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>

            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Video Subtitle</div>
                      <div className={cx(styles.description)}>
                      Enable subtitles for an enriched multimedia experience across the hub and fliteview.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.subtitleEnabled}
                        onChange={() => handleSettingsChange("subtitleEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>
        
          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Seek In Fliteview</div>
                      <div className={cx(styles.description)}>
                      Utilize the power of AI for improved search within assets in Flite View.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.fliteviewSeekEnabled}
                        onChange={() => {
                          handleSettingsChange("fliteviewSeekEnabled")
                        }}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Video Conversion</div>
                      <div className={cx(styles.description)}>
                        Convert video asset into multiple resolutions for adaptive bitrate streaming and audio file to extract text.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.videoConversionEnabled}
                        onChange={() => handleSettingsChange("videoConversionEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns={2}>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Employer Advocacy</div>
                      <div className={cx(styles.description)}>
                      Enable employer advocacy feature to utilize the linkedIn integration.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.employerAdvocacyEnabled}
                        onChange={() => handleSettingsChange("employerAdvocacyEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
            <Grid.Column>
              <Container className={cx(styles.setting)}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={13} className={styles.text}>
                      <div className={cx(styles.label)}>Hey Sales</div>
                      <div className={cx(styles.description)}>
                       Enabling real conversations with buyers, and using rep-generated learning.
                      </div>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={settings.coachingEnabled}
                        onChange={() => handleSettingsChange("coachingEnabled")}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Container>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column textAlign="right">
            <SaveChanges onClick={onSettingsSave} disabled={disabled || disableSave} />
              <Cancel onClick={onSettingsCancel} disabled={disabled} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          onSave={onSettingsChangeConfirm}
          onCancel={onSettingsCancel}
          content={"Are you sure want to save changes?"}
        />
      </Container>
    </>
  );
}
